
const FacetedSearchCheckboxFieldInput = (props) => {

    const getPaddingLeft = () => {
        return props.Indent * 10;
    };

    return (
        <div key={props.ReactKey} className={'faceted-option-checkbox-container ' + (props.AdditionalClassName ? props.AdditionalClassName : props.MustBeSelectedIndividually && !props.MustBeSelectedIndividuallySkipAdditionalStyling ? 'individual-option' : '') + (props.Disabled ? ' faceted-option-checkbox-container__disabled' : '') + (props.FieldName == 'InventoryType' || props.FieldName == 'WinningBidderStatus' ? ' visible' : '')} >
            {props.IsHeading ?
                <label style={{ fontWeight: 'bold' }}>
                    <span className='option-name'>{props.Name}</span>
                </label> :
                <label style={{ paddingLeft: getPaddingLeft() + 'px', fontWeight: props.IsGroup ? 'bold' : 'normal' }}>
                    <input
                        type='checkbox'
                        name={props.FieldName}
                        value={props.Value}
                        onChange={props.CheckboxChange}
                        checked={props.Checked && !props.IsSegmentSelected}
                        disabled={props.Disabled}
                        aria-label={props.Name + ' ' + props.Count}
                    />
                    <span className='option-name'>{props.Name}</span>
                    {props.ShowCounts && <span className='option-count'>({props.Count})</span>}
                </label>}
        </div>
    );
};

export default FacetedSearchCheckboxFieldInput;